module.exports = __webpack_public_path__ + "static/media/profile.0528d0c5.jpg";